import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import { withRouter } from 'react-router-dom';
import Home from '@material-ui/icons/Home';
import Paper from '~/components/Paper';
import useStyles from './styles';
import 'react-placeholder/lib/reactPlaceholder.css';

function Loading({ history }) {
  const classes = useStyles();
  const { route } = history.location;

  return (
    <Paper
      loading
      Icon={Home}
      iconColor={route.color}
    >
      <ReactPlaceholder
        showLoadingAnimation
        className={classes.root}
        ready={false}
        type="text"
        rows={7}
      >
        <Home />
      </ReactPlaceholder>
    </Paper>
  );
}

export default withRouter(React.memo(Loading));
